<template>
  <div id="login">
    <div class="centerDiv">
      <div class="contmain">
        <div class="left-img"></div>
        <!--<img class="leftimgbg" :style="leftimgbg" />-->
        <div class="middle-box loginscreen">
          <div class="logobg pb20">
            <!-- <img :src="loginPageLogo" alt="" v-if="loginPageLogo"> -->
            <img src="../assets/imgs/logo2.png" alt="" />  
            <!-- <div v-else class="logo"></div> -->
          </div>

          <div class="login_box">
            <font>用户登录</font>
            <el-form
              class="login_form"
              ref="userinfo"
              :rules="rules"
              :model="userinfo"
              method="post"
              autocomplete="off"
            >
              <!--<div class="input-group">-->
              <el-form-item prop="username">
                <el-input
                  id="username"
                  placeholder="用户名"
                  v-model="userinfo.username"
                  @keyup.enter.native="checklogin"
                ></el-input>
                <div class="bottom-line"></div>
                <span v-show="null1" class="wrong">{{ ername }}</span>
              </el-form-item>
              <!--</div>-->

              <!--<div class="input-group">-->
              <el-form-item prop="password">
                <el-input
                  type="password"
                  id="password"
                  placeholder="密码"
                  v-model="userinfo.password"
                  @keyup.enter.native="checklogin"
                ></el-input>
                <div class="bottom-line"></div>
                <span v-show="null2" class="wrong">{{ erpass }}</span>
              </el-form-item>
              <!--</div>-->

              <div class="clearfix" v-if="isopenCalidator == 1">
                <el-form-item
                  label=""
                  prop="verifycode"
                  label-width="0px"
                  class="pull-left rememberbg"
                  :rules="{ required: true, trigger: 'blur', message: '必填' }"
                >
                  <el-input
                    type="text"
                    length="80px"
                    placeholder="验证码"
                    v-model="userinfo.verifycode"
                    @keyup.enter.native="checklogin"
                    prefix-icon="el-icon-s-check"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label=""
                  label-width="0px"
                  class="pull-right forget"
                >
                  <a
                    href="javascript:void(0)"
                    class="verification-code"
                    @click="getVerifycode()"
                  >
                    <!--< img :src="codeurl" height="36" width="100" />-->
                    <span
                      :style="
                        'background-image:url(' +
                        this.codeurl +
                        '); height:36px; width:100px; display:block;'
                      "
                    ></span>
                  </a>
                </el-form-item>
              </div>

              <div class="input-group">
                <div class="pull-left rememberbg">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="勾选后密码将记录7天"
                    placement="top"
                  >
                    <el-checkbox v-model="userinfo.remember"
                      >记住密码</el-checkbox
                    >
                  </el-tooltip>
                </div>

                <!-- <div class="pull-right forget">
                  <a href="#">忘记密码？</a>
                </div> -->
              </div>

              <div class="input-group">
                <button type="button" class="btn-login" @click="checklogin">
                  登 录
                </button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="hiddenDiv"></div>
    <!-- <div class="footer-content">
      Copyright ©2020 包头铝业EAM资产管理系统 All Rights Reserved.
    </div>  -->
  </div>
</template>

<script>
import Utils from '../utils'
import 'url-search-params-polyfill'
export default {
  name: 'login',
  // 记住密码
  data() {
    return {
      msg: '泰康健投EAM实物资产管理项目',
      ername: '',
      erpass: '',
      isopenCalidator: '',//是否开启验证码
      null1: false,
      null2: false,
      userinfo: {
        username: '',
        password: '',
        verifycode: '',
        remember: ''// 记住密码
      },
      verifycodeimg: "", //验证码图片
      deviceId: "", //验证码图片的随机数
      codeurl: "", //从后端获取验证码图片的url
      loginPageCopyright: '',
      loginPageLogo: '',
      rules: {// required: true,必填标题加红*
        username: [{ required: true, trigger: 'blur', message: '必填' }],
        password: [{ required: true, trigger: 'blur', message: '必填' }],
      },
      loginbg: {
        height: "100%",
        background: "url(" + require("../assets/imgs/loginbg.png") + ") #F5F8FB right bottom no-repeat"
      },
      leftimgbg: {
        backgroundImage: "url(" + require("../assets/imgs/login-left.png") + ")",
        backgroundRepeat: "no-repeat",
        width: "591px",
        height: "473px",
        float: "left",
        marginTop: "-3px",
        marginLeft: "77px",
        backgroundSize: "99%",
        borderStyle: "none",
        border: "0",
        allLeftMenusData: [],
      }

    }
  },
  computed: {
    //当前登录人信息
    currentuser() {
      return this.$store.state.currentuser
    },
  },
  methods: {
    //获取验证码图片
    getVerifycode() {
      this.deviceId = this.getRandom(0, 1000);
      this.codeurl = Config.dev_url + "/api-auth/validata/code/" + this.deviceId;
    },
    //获取随机用，用于验证码图片
    getRandom(n, m) {
      var n = Number(n); //强制转换成数字
      var m = Number(m);
      if (isNaN(n) || isNaN(m)) { //判断是否为有效数字 ，其中一个不是有效数字就返回[0,1)之间的随机小数
        return math.random();
      }
      if (n > m) { //如果n>m则交换
        var temp = n;
        n = m;
        m = temp;
      }
      return Math.round(Math.random() * (m - n) + n);
    },
    //查询是否为第一次登录
    isfirstlogininit() {
      var url = Config.dev_url + '/api-user/settings/firstlogininit'
      this.$axios.get(url).then((res) => {
        console.log(res, "查询是否第一次登录")
        if (res.data == 0) {
          this.$router.push('/index')
        } else {
          this.$router.push('/firstLogin')
        }
      })
    },
    getAllMenu() {
      var url = Config.dev_url + '/api-user/menus/findMenuByRoleCode/' + this.currentuser.rolecode
      this.$axios.get(url).then((res) => {
        this.$store.commit("setallMenuData", res.data)
      }).catch((err) => {
      })
    },
    checklogin() {
      this.$refs.userinfo.validate(valid => {
        if (valid) {
          if (this.userinfo.remember == true) { // 如果用户点击勾选了记住密码
            // 传入账号名，密码，和保存天数3个参数
            this.setCurrentCookie(this.userinfo.username, this.userinfo.password, this.userinfo.remember, 7)
          } else {
            // 清空Cookie
            this.clearCookie()
          }
          let param = new URLSearchParams();
          param.append("username", this.userinfo.username);
          let pwd = Utils.encrypt(this.userinfo.password, "hAw6eqnFLKxpsDv3");
          param.append("password", pwd);
          if (this.isopenCalidator == 1) {
            param.append("deviceId", this.deviceId);
            param.append("validCode", this.userinfo.verifycode);
          }
          var url = Config.dev_url + '/api-auth/oauth/user/token';
          this.$axios({ method: "post", url: url, data: param, headers: { "client_id": "webApp", "client_secret": "webApp" } }).then((res) => {
            if (res.data.access_token) {
              //   this.$store.commit("setexpirationtime",res.data.expires_in)
              console.log(this.$store.state.expirationtime)
              this.setCookie('access_token', res.data.access_token)
              this.setCookie('expires_in', res.data.expires_in)
              this.setCookie('refresh_token', res.data.refresh_token)
              // this.$router.push('/index')
              // this.$router.push('/firstLogin')
              this.getUser().then(() => {
                // this.isfirstlogininit()
                this.getAllMenu();
                this.$router.push('/index')
              })
            }
          })
            .catch(res => {
              // console.log(res)
              if (!!res.rsp_msg) {
                if (res.rsp_msg == "Bad credentials") {
                  this.$message({
                    message: '用户名或密码错误',
                    type: 'warning'
                  });
                }
                else {
                  this.$message({
                    message: res.rsp_msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: '登录失败',
                  type: 'warning'
                });
              }
              if (this.isopenCalidator == 1) {
                this.getVerifycode();// 需要判断是否调用 heliping20200730
              }
            })
        }
        else {
          this.$message({
            message: '用户名、密码、验证码未填写完整，请先填写！',
            type: 'warning'
          })
        }
      })
    },
    //获取当前用户信息
    getUser() {
      return new Promise((resolve) => {
        var url = Config.dev_url + '/api-user/users/currentMap';
        this.$axios.get(url, {}).then((res) => {//获取当前用户信息
          this.$store.commit("setCurrentuser", res.data)
          resolve()
        }).catch((err) => {
        });
      })
    },
    // 设置cookie
    setCurrentCookie(c_name, c_pwd, c_remb, exdays) {
      var exdate = new Date() // 获取时间
      var newc_pwd = Utils.encrypt(c_pwd, 'hAw6eqnFLKxpsDv3') // 密码加密
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      this.setCookie('userNam', c_name) // 用户名
      this.setCookie('userPwd', newc_pwd) // 密码
      this.setCookie('userRem', c_remb) // 记住密码
    },
    // 读取Cookie并给登录文本框赋值
    getCookies() {
      //   å console.log(document.cookie) // 打印cookie看一下
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] == 'userNam') {
            this.userinfo.username = arr2[1] // 赋值给username
          } else if (arr2[0] == 'userPwd') {
            // Utils.decrypt解密  第一个参数是待解密的字符串，第二个参数是aes加密需要用到的16位字符串的key
            this.userinfo.password = Utils.decrypt(arr2[1], 'hAw6eqnFLKxpsDv3') // 密码解密赋值给password
          } else if (arr2[0] == 'userRem') {
            this.userinfo.remember = eval(arr2[1].toLowerCase()) // 把字符串true转换成布尔值赋值给remember
          }
        }
      }
    },
    // 清除cookie
    clearCookie() {
      this.setCurrentCookie('', '', '', -1) // 修改2值都为空，天数为负1天就好了
      sessionStorage.clear() // 清空当前tab浏览器的Cookie
      localStorage.clear() // 清空当前tab浏览器的Cookie
      this.delCookie('access_token');
      this.delCookie('currentrolesname');
      this.delCookie('expires_in');
      this.delCookie('refresh_token');
      this.delCookie('store');
      this.delCookie('RoleId');
      //   this.$store.dispatch('setRoleIdAct', null)
      //   this.$store.dispatch('setNavIdAct', null)
      //   this.$store.dispatch('setcurrentrolesnameNavAct', null)
      //   this.$store.commit("setexpirationtime",0)
    },
    getLogoAndCopyright() {
      //登录页logo
      var url = Config.dev_url + '/api-user/settings/anon/loginLogo'
      this.$axios.get(url, { noToken: true }).then((res) => {
        // console.log(res,"登录页logo")
        this.loginPageLogo = res.data
      })
      //登录页版权
      var url1 = Config.dev_url + '/api-user/settings/anon/loginCopyright'
      this.$axios.get(url1, { noToken: true }).then((res) => {
        // console.log(res,"登录页版权")
        this.loginPageCopyright = res.data
      })
      //判断登录时是否使用验证码
      var url2 = Config.dev_url + '/api-user/settings/anon/loginIdentifyingCode'
      this.$axios.get(url2, {}).then((res) => {
        console.log(res.data)
        this.isopenCalidator = res.data //0是不开启，1是开启
        // console.log(res,"登录页版权")
        // this.loginPageCopyright = res.data
      })
    }
  },
  mounted() {
    this.clearCookie()
    this.getCookies()
    // this.getVerifycode()
    // this.getLogoAndCopyright()
  }
}
</script>

<style scoped>
@import "./login.css";
.el-checkbox,
.el-radio {
  line-height: 20px !important;
}
</style>
